import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ReferenceDataActionTypes,
  LoadReferenceDataItemAction,
  LoadReferenceDataItemFailAction,
  LoadReferenceDataItemSuccessAction,
  LoadReferenceDataAction,
  LoadReferenceDataFailAction,
  LoadReferenceDataSuccessAction,
} from './reference-data.actions';
import { ReferenceDataManagementUiLibraryService } from './reference-data-management-ui-library.service';
import { LoadReferenceDataItemPayload } from './load-reference-data-item-payload';
import { TypedReferenceData } from './models/typed-reference-data';
import { GenericReferenceData } from './models/generic-reference-data';

@Injectable()
export class ReferenceDataEffects<T extends GenericReferenceData> {

  @Effect()
  loadReferenceDataItem$: Observable<Action> =
    this.actions$.pipe(
      ofType(ReferenceDataActionTypes.LoadReferenceDataItem),
      map((action: LoadReferenceDataItemAction<T>) => action.payload),
      switchMap(
        (payload: LoadReferenceDataItemPayload<T>) => {
          return this.referenceDataManagementUiLibraryService.loadReferenceDataItem(payload)
            .pipe(
              map((data: TypedReferenceData<T>) => new LoadReferenceDataItemSuccessAction(data)),
              // tslint:disable-next-line:no-any
              catchError((error: any) => of(new LoadReferenceDataItemFailAction(error))),
            );
        },
      ),
    );

  @Effect()
  loadReferenceDataItems$: Observable<Action> =
    this.actions$.pipe(
      ofType(ReferenceDataActionTypes.LoadReferenceData),
      map((action: LoadReferenceDataAction<T>) => action.payload),
      switchMap(
        (payload: LoadReferenceDataItemPayload<T>[]) => {
          return this.referenceDataManagementUiLibraryService.loadReferenceDataItems(payload)
            .pipe(
              map((data: TypedReferenceData<T>[]) => new LoadReferenceDataSuccessAction(data)),
              // tslint:disable-next-line:no-any
              catchError((error: any) => of(new LoadReferenceDataFailAction(error))),
            );
        },
      ),
    );

  constructor(private actions$: Actions,
              private referenceDataManagementUiLibraryService: ReferenceDataManagementUiLibraryService<T>) {
  }
}
